import type { SoManagerPicturePartsFragment } from '~/apollo/generated/v4/graphql';
import { Heading } from '~/components/common/Heading';
import { SOPictureCard } from '~/components/upload/supporting-object/so-picture-card';
import type { RefetchQueries } from '~/utils/graphql';
import { OutcropThumbnailUploader } from './outcrop-thumbnail-uploader';

export function OutcropThumbnailManager({
  outcropId,
  outcropName,
  thumbnail,
  refetchQueries,
}: {
  outcropId: number;
  outcropName: string;
  thumbnail: SoManagerPicturePartsFragment | null | undefined;
  refetchQueries: RefetchQueries;
}) {
  return (
    <div className="">
      {thumbnail ? (
        <SOPictureCard picture={thumbnail} refetchQueries={refetchQueries} />
      ) : (
        <div>
          <Heading level={4}>Upload Thumbnail</Heading>
          <OutcropThumbnailUploader
            outcropId={outcropId}
            outcropName={outcropName}
            refetchQueries={refetchQueries}
          />
        </div>
      )}
    </div>
  );
}
